import { render, staticRenderFns } from "./statistic_product.vue?vue&type=template&id=d5b2f7c8&scoped=true"
import script from "./statistic_product.vue?vue&type=script&lang=js"
export * from "./statistic_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b2f7c8",
  null
  
)

export default component.exports